<template>
  <div class="lyear-layout-web">
    <div class="lyear-layout-container">
      <!--左侧导航-->
      <user-left></user-left>
      <!--End 左侧导航-->
      
      <!--头部信息-->
      <user-head></user-head>
      <!--End 头部信息-->
      
      <!--页面主要内容-->
			<main class="lyear-layout-content">
				
				<div class="container-fluid">
					
					<div class="row">
						<div class="col-lg-12">
							<div class="card">
								<div class="card-body">
									<div class="form-group">
										<label for="old-password">旧密码</label>
										<input type="password" class="form-control" v-model="oldPassword"  placeholder="输入账号的原登录密码">
									</div>
									<div class="form-group">
										<label for="new-password">新密码</label>
										<input type="password" class="form-control" v-model="newPassword"  placeholder="输入新的密码">
									</div>
									<div class="form-group">
										<label for="confirm-password">确认新密码</label>
										<input type="password" class="form-control" v-model="newPassword_aga" placeholder="与新密码相同">
									</div>
									<button @click="submitChange" class="btn btn-primary">修改密码</button>
								</div>
							</div>
						</div>
						
					</div>
					
				</div>
				
			</main>
      <!--End 页面主要内容-->
    </div>
  </div>
</template>

<script>
import userLeft from './user_left.vue'
import userHead from './user_head.vue'
export default {
  data () {
    return {
			oldPassword: '',
			newPassword: '',
			newPassword_aga: ''
		}
  },
	
	components: {
		userLeft,
		userHead
	},

  created () {
	},

  methods: {
		// 修改密码
		async submitChange () {
			let _this = this
			let { oldPassword, newPassword, newPassword_aga } = _this
			if (oldPassword =='' || newPassword =='' || newPassword_aga =='') {
				return _this.$Message.warning('请检查输入内容不能为空')
			}
			if (newPassword != newPassword_aga) {
				return _this.$Message.warning('两次新密码输入不一致')
			}
			const res = await _this.post('/user/modifyPsw.do?oldPassword=' + oldPassword + '&newPassword=' + newPassword)
			if (res.result == 1) {
				_this.$Message.success('修改成功')
				localStorage.removeItem('token')
				localStorage.removeItem('username')
				localStorage.removeItem('picture')
				_this.$router.replace({path:'/register'})
			} else {
				_this.$Message.error(res.error.errorMsg)
			}
		},
	}
}
</script>

<style lang="less" scoped>

</style>
